<template>
  <div>
    <ul class="self-page-menu">
      <li v-for="(item,i) in pageMenu" :key="item.id" @click="changePage(item.id)" :class="{'self-active-node':activeNode==i}">{{item.name}}<i class="el-icon-caret-right self-icon"></i></li>
    </ul>
  </div>
</template>


<script>
export default {
  name: "standardMenu",
  props:{
    pageMenu:{
      type:Array,
      default:()=>[]
    }
  },
  data(){
    return {
      activeNode:0
    }
  },
  methods:{
    changePage(i){
      this.activeNode = i;
      this.$emit("switchPageMenu",this.activeNode)
    }
  },
}
</script>

<style lang="scss" scoped>
.self-page-menu{
  list-style:none;
  padding:0;
  margin:0;
  li{
    cursor:pointer;
    color:#666;
    font-size:20px;
    height: 37px;
    padding: 33px 40px 14px;
    vertical-align:text-top;
    line-height: 18px;
    .self-icon{
      float:right;
    }
  }
  .self-active-node{
    color:#ffffff;
    background-color: rgba(0,0,0,.4);
  }
}
</style>



// WEBPACK FOOTER //
// src/veiws/standardMenu.vue